import React from 'react';
import {
  theme,
  Banner,
  Box,
  Flex,
  Dropover,
  Text,
} from '@xometry/xometry_loft';
import OrganizationRoleColors, {
  OrganizationRoleDescriptions,
} from '../UserInitialBox/OrganizationRoleStaticData';
import { css } from '@emotion/react';

const OrganizationRoleCard = ({
  role,
  count,
}: {
  role: string;
  count: number;
}) => {
  const cardTitleTooltip = (
    <Flex flexDirection="row" justifyContent="space-between">
      <Box
        css={css`
          text-transform: capitalize;
        `}
      >{`${role}${'s'}`}</Box>
      {!!OrganizationRoleDescriptions[role] && (
        <Box>
          <Dropover alignment="right" placement="top">
            <Dropover.Trigger>
              <Box color={theme.colors.blues[100]}>
                <i className="fa-regular fa-circle-info" title={''} />
              </Box>
            </Dropover.Trigger>
            <Dropover.Content width="250px">
              <Text kind="body-sm">{OrganizationRoleDescriptions[role]}</Text>
            </Dropover.Content>
          </Dropover>
        </Box>
      )}
    </Flex>
  );

  return (
    <Banner
      bannerTitle={cardTitleTooltip}
      scale={theme.scale.small}
      customBorderColor={
        OrganizationRoleColors[role] || theme.colors.darkBlues[90]
      }
    >
      <Box
        color={theme.colors.darkBlues[75]}
        fontSize={theme.fontSizes[0]}
        fontWeight={theme.fontWeights.semibold}
        css={css`
          text-transform: capitalize;
        `}
      >
        <i className="fa-solid fa-users" /> {count} Team{' '}
        {`${role}${count !== 1 ? 's' : ''}`}
      </Box>
    </Banner>
  );
};

export default OrganizationRoleCard;
